var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1297 7.87318C1.04485 7.50811 1 7.1277 1 6.73682C1 6.34593 1.04485 5.96552 1.1297 5.60045M5.09091 1.81926C5.38571 1.76511 5.68955 1.73682 6 1.73682C8.76142 1.73682 11 3.97539 11 6.73682C11 9.49824 8.76142 11.7368 6 11.7368C5.68955 11.7368 5.38571 11.7085 5.09091 11.6544M3.5 2.40573C2.81801 2.80024 2.23785 3.3512 1.8086 4.00954M1.8086 9.46409C2.23785 10.1224 2.81801 10.6734 3.5 11.0679M6 8.7417V6.2417M6 4.7417V4.7367",
    stroke: "#92929E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTooltip);
export default __webpack_public_path__ + "static/media/icn_tooltip.976cf778855e9449a3052a43233f53f7.svg";
export { ForwardRef as ReactComponent };